import React, { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Title, Text, SubTitle } from "../theme";
import { checkStoredOrPromptPassword } from "../utilities/passwordCookie";

const MemeTable = () => {
  const [memes, client, settings] = useSelector((state) => [
    state.data.memes || [],
    state.data.client,
    state.data.settings,
  ]);

  const [secure, setSecure] = useState(null);

  const allColumns = useMemo(() => {
    const set = new Set();
    memes.forEach((m) =>
      Object.keys(m).forEach((key) => {
        if (key !== "email") set.add(key);
      })
    );
    return Array.from(set);
  }, [memes]);

  const [visibleColumns, setVisibleColumns] = useState(["img", "finished"]);

  //   const [visibleColumns, setVisibleColumns] = useState(() => [...allColumns]);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  //   useEffect(() => {
  //     setVisibleColumns(allColumns);
  //   }, [allColumns]);

  useEffect(() => {
    if (secure === null && settings) {
      setSecure(checkStoredOrPromptPassword(settings.password));
      // setSecure(true);
    }
  }, [secure, settings]);

  const toggleColumn = (key) => {
    setVisibleColumns((prev) =>
      prev.includes(key) ? prev.filter((col) => col !== key) : [...prev, key]
    );
  };

  const requestSort = (key) => {
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: "asc" }
    );
  };

  const sortedMemes = useMemo(() => {
    if (!sortConfig.key) return memes;

    return [...memes].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];
      const direction = sortConfig.direction === "asc" ? 1 : -1;

      if (aVal == null) return 1;
      if (bVal == null) return -1;

      if (typeof aVal === "string") return aVal.localeCompare(bVal) * direction;
      if (typeof aVal === "number") return (aVal - bVal) * direction;

      return 0;
    });
  }, [memes, sortConfig]);

  if (secure === false) {
    return (
      <Row center="xs">
        <Col xs={12}>
          <Title style={{ color: "white" }}>Meme Table</Title>
          <Text style={{ color: "white" }}>Wrong password.</Text>
        </Col>
      </Row>
    );
  }

  if (!secure) {
    return null;
  }

  if (!memes.length) {
    return (
      <Row center="xs">
        <Col xs={12}>
          <Text style={{ color: "white" }}>No memes found.</Text>
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Row center="xs">
        <Col xs={12}>
          <Title style={{ color: "white" }}>Meme Table</Title>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <SubTitle style={{ color: "white" }}>Toggle Columns</SubTitle>
          {allColumns.map((key) => (
            <button
              key={key}
              onClick={() => toggleColumn(key)}
              style={{
                marginRight: "8px",
                marginBottom: "6px",
                background: visibleColumns.includes(key) ? "#444" : "#222",
                color: "white",
                border: "1px solid white",
                padding: "4px 8px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              {visibleColumns.includes(key) ? `Hide ${key}` : `Show ${key}`}
            </button>
          ))}
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "20px",
                color: "white",
              }}
            >
              <thead>
                <tr>
                  {visibleColumns.map((col) => (
                    <th
                      key={col}
                      onClick={() => requestSort(col)}
                      style={{
                        cursor: "pointer",
                        borderBottom: "1px solid white",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {col}
                      {sortConfig.key === col &&
                        (sortConfig.direction === "asc" ? " ▲" : " ▼")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedMemes.map((meme, i) => (
                  <tr key={meme._id || meme.number || i}>
                    {visibleColumns.map((col) => {
                      const val = meme[col];
                      let content;

                      if (!val) {
                        content = "";
                      } else if (typeof val === "object") {
                        if (val.asset?.url) {
                          content = (
                            <img
                              src={`${val.asset.url}?w=200`}
                              alt={col}
                              style={{
                                maxWidth: "200px",
                                maxHeight: "200px",
                                objectFit: "contain",
                              }}
                            />
                          );
                        } else if (
                          Array.isArray(val) &&
                          val.length &&
                          val[0].name
                        ) {
                          // Nice rendering for taxonomy-style arrays
                          content = val.map((tag) => tag.name).join(", ");
                        } else {
                          content = JSON.stringify(val);
                        }
                      } else {
                        if (
                          typeof val === "string" &&
                          val.match(/^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)$/i)
                        ) {
                          content = (
                            <img
                              src={val.toString()}
                              alt={col}
                              style={{
                                maxWidth: "200px",
                                maxHeight: "300px",
                                objectFit: "contain",
                              }}
                            />
                          );
                        } else {
                          content = String(val);
                        }
                      }

                      return (
                        <td
                          key={`${col}-${i}`}
                          style={{
                            borderBottom: "1px solid #444",
                            padding: "8px",
                            fontSize: "0.9em",
                            verticalAlign: "top",
                          }}
                        >
                          {content}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default MemeTable;
